export const BANNER_OUTPUT_WIDTH = 1500;
export const BANNER_OUTPUT_HEIGHT = 500;
export const BANNER_ASPECT = BANNER_OUTPUT_WIDTH / BANNER_OUTPUT_HEIGHT;

export const LOGO_OUTPUT_SIZE = 1000;
export const LOGO_ASPECT = 1;

export const BANNER_ASPECT_TOLERANCE = 0.018;
export const LOGO_ASPECT_TOLERANCE = 0.018;

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener("load", () => resolve(img));
    img.addEventListener("error", () => reject(new Error("Image failed to load")));
    img.src = src;
  });
}

export function isBannerAspectMatching(naturalWidth, naturalHeight) {
  if (naturalHeight <= 0) return false;
  const r = naturalWidth / naturalHeight;
  return Math.abs(r - BANNER_ASPECT) <= BANNER_ASPECT_TOLERANCE;
}

export function isLogoAspectMatching(naturalWidth, naturalHeight) {
  if (naturalHeight <= 0) return false;
  const r = naturalWidth / naturalHeight;
  return Math.abs(r - LOGO_ASPECT) <= LOGO_ASPECT_TOLERANCE;
}

export async function exportCropToJpegBlob(
  imageSrc,
  pixelCrop,
  outputWidth,
  outputHeight,
  quality = 0.92,
) {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = outputWidth;
  canvas.height = outputHeight;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Could not get canvas context");
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outputWidth,
    outputHeight,
  );
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) resolve(blob);
        else reject(new Error("Image export failed"));
      },
      "image/jpeg",
      quality,
    );
  });
}

export async function exportBannerCropToJpegBlob(imageSrc, pixelCrop, quality = 0.92) {
  return exportCropToJpegBlob(
    imageSrc,
    pixelCrop,
    BANNER_OUTPUT_WIDTH,
    BANNER_OUTPUT_HEIGHT,
    quality,
  );
}

export async function exportLogoCropToJpegBlob(imageSrc, pixelCrop, quality = 0.92) {
  return exportCropToJpegBlob(
    imageSrc,
    pixelCrop,
    LOGO_OUTPUT_SIZE,
    LOGO_OUTPUT_SIZE,
    quality,
  );
}

/** Scale the full frame to the launch output size so drafts stay under localStorage quota. */
export async function exportFullImageToJpegBlob(
  imageSrc,
  outputWidth,
  outputHeight,
  quality = 0.85,
) {
  const image = await loadImage(imageSrc);
  return exportCropToJpegBlob(
    imageSrc,
    { x: 0, y: 0, width: image.naturalWidth, height: image.naturalHeight },
    outputWidth,
    outputHeight,
    quality,
  );
}

export function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Could not read image"));
    reader.readAsDataURL(blob);
  });
}
